export default __webpack_public_path__ + "static/media/026-kepi.7bf700ea.svg";